module.exports = __webpack_public_path__ + "static/media/state-back-12.3545c44a.jpg";